export default __webpack_public_path__ + "static/media/arrow.364cdc91.svg";